import { connect } from 'react-redux';
import { setLinkState } from 'core/slices/link';
import Link from '../../../components/features/link/Link';

export default connect(state => ({}), { 
  setLinkState
})(Link);